export default {
  create: {
    title: 'Adicionar',
    subtitle: 'Letrex',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Letrex',
    button: {
      add: 'Novo jogo',
    },
  },
  list: {
    title: 'Letrex',
    subtitle: 'Lista',
    add: 'Novo jogo',
  },
  card: {
    title: 'Letrex',
    actions: 'Ações',
  },
  table: {
    title: 'Jogos Ativos',
    searchPlaceholder: 'Procurar por algo...',
  },
  form: {
    name: {
      label: 'Nome:',
      placeholder: 'Ex: Letrex Nível 1',
      invalid: 'Nome é obrigatório',
    },
    rows: {
      label: 'Linhas:',
    },
    columns: {
      label: 'Colunas:',
    },
    level: {
      label: 'Nível:',
      placeholder: 'Selecione o nível...',
    },
    generationMode: {
      label: 'Forma de geração:',
      placeholder: 'Selecione a forma...',
      options: {
        simple: 'Simples',
        distribution: 'Distribuição',
      },
    },
    wordLengthRange: {
      section: 'Distribuição',
      min: {
        label: 'Tamanho mínimo',
        tooltip: 'Tamanho mínimo das palavras geradas.',
      },
      max: {
        label: 'Tamanho máximo',
        tooltip: 'Tamanho máximo das palavras geradas.',
      },
    },
    prioritizeQuality: {
      label: 'Priorizar qualidade',
      tooltip:
        'Roda tentativas extras depois da geração principal para tentar melhorar o resultado. Pode demorar mais.',
    },
    avoidSimilarWords: {
      label: 'Evitar palavras similares',
      tooltip:
        'O sistema evitará palavras que possuem similaridades significativas com as palavras já presentes no grid.',
    },
    wordsList: {
      label: 'Lista de palavras:',
      copyTooltip: 'Copiar lista para a área de transferência',
    },
    grid: {
      cellLabel: 'Célula linha {row}, coluna {col}',
    },
  },
  sidebar: {
    exportHint: 'Você precisa salvar antes de exportar.',
    defaultFileName: 'letrex',
  },
  button: {
    generate: 'Gerar Jogo',
  },
  alert: {
    gameSaved: 'Jogo salvo com sucesso!',
    cleared: 'Grade limpa com sucesso!',
    generated: 'Letrex gerado com sucesso!',
    generateFailed: 'Não foi possível gerar o Letrex.',
    wordLengthRangeInvalid:
      'Informe um intervalo válido de tamanho de palavras (mín. ≤ máx.).',
    wordsListCopied: 'Lista de palavras copiada!',
    wordsListCopyFailed: 'Não foi possível copiar a lista de palavras.',
    sendSuccess: 'Enviado com sucesso',
    sendError: 'Erro ao enviar. Tente novamente.',
  },
};
